export const REQUEST_POST_MESSAGE = 'REQUEST_POST_COMMENT'
export const RECEIVE_POST_MESSAGE = 'RECEIVE_POST_MESSAGE'
export const HANDLE_POST_MESSAGE_ERROR = 'HANDLE_POST_MESSAGE_ERROR'
export const ADD_MUNICIPALITY_DATA = 'ADD_MUNICIPALITY_DATA'
export const SHOW_FORM = 'SHOW_FORM'
export const UPDATE_TEXTAREA_LENGTH = 'UPDATE_TEXTAREA_LENGTH'

export function updateTextAreaLength (length): Object {
  return {
    type: UPDATE_TEXTAREA_LENGTH,
    length
  }
}

export function showForm (): Object {
  return {
    type: SHOW_FORM
  }
}

export function addMunicipalityData (municipality: Object): Object {
  return {
    type: ADD_MUNICIPALITY_DATA,
    municipality
  }
}

function requestPostMessage (): Object {
  return {
    type: REQUEST_POST_MESSAGE
  }
}

function receivePostMessage (result): Object {
  return {
    type: RECEIVE_POST_MESSAGE,
    result
  }
}

function handlePostMessageError (error): Object {
  return {
    type: HANDLE_POST_MESSAGE_ERROR,
    error
  }
}

function handleError (response) {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}

export function postMessage (actionUrl: string, postData: Object) {
  return (dispatch) => {
    dispatch(requestPostMessage())
    return fetch(actionUrl, {
      method: 'POST',
      body: JSON.stringify(postData)
    })
      .then((res) => handleError(res).json())
      .then((data) => dispatch(receivePostMessage(data)))
      .catch((err) => dispatch(handlePostMessageError(err)))
  }
}



// WEBPACK FOOTER //
// ./src/shared/actions/form.js